export default {
    'posting-type':'Posting Pattern',
    'accountant-then-warehouser': 'Accountant then warehouser',
    'warehouser-then-accountant':'Warehouse then accountant',
    'no-priority': 'No priorities',
    'customize-financial-files': 'Customize Financial Files',
    'customized-financial-files': 'Customized Financial Files',
    'customize-setting': "Personalizar configuración",
    'setting-name': "Nombre de la configuración",
    'un-customize-setting': "Quitar personalización de la configuración",
    'un-customize-setting-description': "¿Estás seguro de que deseas quitar la personalización de esta configuración? Ten en cuenta que se aplicará la configuración a nivel del sistema.",
    'un-customize': "Quitar personalización",
    'Posting Pattern': {
        "title": 'Posting Priority',
        "icon": '<i class="fas fa-sort-amount-down-alt primary--text"></i>'
    },
    'showCounterAccount': {
        "title": "Show Counter Account",
        "icon": '<i class="fas fa-user-alt primary--text"></i>'
    },
    "useAltCurrencyBalancing": {
        "title" : "Alternative Currency Bonds Balancing",
        "icon": '<i class="fas fa-balance-scale primary--text"></i>'
    } ,
    "QtyColor": {
        "title": "Quantity alert when exceeding material limits",
        "icon": '<i class="fas fa-exclamation-circle primary--text"></i>'
    },
    "ValidateAccountType": {
        "title": "Restrict final accounts – Trading only",
        "icon": "<i class='fas fa-user-alt-slash primary--text'></i>"
    },
    "UseDocNoInsteadOfInvoiceNo": {
        "title": "Display the manual document number instead of the invoice number in the ledger report",
        "icon": "<i class='mdi mdi-numeric primary--text'></i>"
    },
    "ShowDateEntry": {
        "title": "Display the entry date field and allow editing it in the accounting and cash journal",
        "icon": "<i class='fas fa-calendar-alt primary--text'></i>"
    },
    "CanAddFutureDate": {
        "title": "Ability to add future dates to invoices and items",
        "icon": "<i class='mdi mdi-sort-calendar-descending primary--text text-h5'></i>"
    },
    "ReverseCurrencyPrice": {
        "title": "Reverse the direction of currency price calculation within accounting and cash journals when using a currency different from the system currency",
        "icon": "<i class='mdi mdi-swap-vertical primary--text text-h5'></i>"
    },
    "UseMaterialSerialNumber": {
        "title": "Display the serial number of the material in invoices",
        "icon": "<i class='mdi mdi-barcode-scan primary--text text-h5 mt-2'></i>"
    },
    "ShowMaterialSpecifications": {
        "title": "Display the material specifications in invoices and price display",
        "icon": "<i class='fas fa-info primary--text me-1'/>"
    },
    "DuplicateSerialNumAlert": {
        "title": "Duplicate serial number alert between materials",
        "icon": "<i class='far fa-clone primary--text me-1'></i>"
    },
    "UseRandomNumber": {
        "title": "Encode quotation number when printing",
        "icon": "<i class='mdi mdi-counter primary--text text-h5 mt-2'></i>"
    },
    "UseInvoiceDateInsteadOfCurrentDate": {
        "title": "Use invoice date instead of current date on export",
        "icon": "<i class='mdi mdi-calendar primary--text text-h5 mt-2'></i>"
    },
    "ProfessionalAccountingColorMode": {
        "title": "Advanced Coloring Mode",
        "icon": "<i class='mdi mdi-palette-advanced primary--text me-1'></i>"
    },
    "hideDeleteBondButton": {
        "title": "Hide Delete Button in Accounting and Cash Journals",
        "icon": "<i class='fas fa-trash-alt primary--text me-1'></i>"
    }


}